import React from 'react';
import NotificationContent from '../_partials/NotificationContent';
import { useCustomNotifications } from '../CustomNotificationContext';
export const CustomNotification = ({ notificationTypes , notificationFilter =()=>true , customNotificationRender  })=>{
    const { notifications , removeNotification  } = useCustomNotifications(notificationTypes);
    const currentNotification = notifications[0];
    if (!currentNotification || !notificationFilter(currentNotification)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(NotificationContent, {
        notification: currentNotification,
        removeNotification: removeNotification
    }, customNotificationRender);
};
CustomNotification.displayName = 'CustomNotification';
export default CustomNotification;
